import {
  ArrowBack,
  Business,
  Category,
  Search as SearchIcon,
  Description,
  Event,
} from "@material-ui/icons";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled, { keyframes, StyleSheetManager } from "styled-components";

import NewWindow from "react-new-window";

import "react-tabs/style/react-tabs.css";
import fetchClient from "../../api/fetchClient";
import Loader from "../../components/Loader";

import LogEvents from "../../components/LogEvents";
import SearchLogs from "../../components/SearchLogs";

import Transaction from "../../components/logs/Transaction";
import { RowActions } from "../../components/logs/TransactionsTable";
import message from "../../helper/message";

function Logs() {
  const history = useHistory();
  const [logs, setlogs] = useState([]);
  const [pending, setPending] = useState(false);
  const [pendings, setPendings] = useState([]);
  const [next, setNext] = useState(1);
  const [pendingView, setPendingView] = useState(null);
  const [empresa, setEmpresa] = useState("");
  const [groupsLogs, setGroupsLogs] = useState([]);
  const [groupLog, setGroupLog] = useState(null);
  const [isOpened, setIsOpened] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRemoving, setIsRemoving] = useState(false);
  const [logToRemove, setLogToRemove] = useState(null);
  const [type, setType] = useState("");
  const [windowFeatures, setWindowFeatures] = useState(
    "left=0,top=0,width=1200,height=700,resizable=yes,scrollbars=yes"
  );
  const [logWindow, setLogWindow] = useState(null);

  const [empresas, setEmpresas] = useState([]);

  const [nextPage, setNextPage] = useState({
    has: false,
    link: null,
  });

  const [loading, setLoading] = useState(-1);

  function RemoveModal() {
    return (
      <Outlayer>
        <ModalContainer>
          <ModalContent>
            <ModalTitle>Desja remover?</ModalTitle>
            <ModalButtons>
              <ConsultResult onClick={() => handleRemove()}>Sim</ConsultResult>
              <ConsultResult onClick={() => setIsRemoving(false)}>
                Não
              </ConsultResult>
            </ModalButtons>
          </ModalContent>
        </ModalContainer>
      </Outlayer>
    );
  }

  const getEmpresas = async () => {
    const logs = JSON.parse(localStorage.getItem("user")).logs;
    const { data } = await fetchClient.get("/getAllConcur");
    const empresas = data.value.map((log) => {
      if (logs.find((item) => item.id === log.id)) {
        return {
          id: log.id,
          name: log.name,
          ativo: log.ativo,
        };
      } else return null;
    });
    console.log(empresas);
    setlogs(empresas || []);
    setIsLoading(false);
  };

  const handleRemove = async () => {
    try {
      const url = `${
        pending ? "removeLogById" : "removeLog"
      }/${empresa}/${logToRemove}?type=${type}`;
      const { data } = await fetchClient.get(url);
      if (data[0].acknowledgeResult === "FAILURE") {
        message.error(data[0].errorMessage);
      } else {
        message.sucess("Documento removido com sucesso!");
      }
    } catch {
      message.error("Timeout ao tentar deletado!");
    }
    setIsRemoving(false);
  };

  useEffect(() => {
    getEmpresas();
  }, []);

  useEffect(() => {
    console.log(empresa, type);
    if (empresa && type) {
      if (pending) getTransactions(empresa, type);
      else getGroupLogs(empresa, type);
    }
    //eslint-disable-next-line
  }, [empresa, type, pending]);

  const getGroupLogs = async (tenent, type, token = null) => {
    try {
      if (tenent === null || type === null) return;
      setIsLoading(true);
      const { data } = await fetchClient.get(
        `getAllLogs/${tenent}?type=${type}${token ? `&nextToken=${token}` : ""}`
      );
      setGroupsLogs((old) =>
        token ? [...old, ...data.logStreams] : data.logStreams
      );
      if (data.nextToken) setNextPage({ has: true, link: data.nextToken });
      else setNextPage({ has: false, link: null });
    } catch (err) {
      message.error(err.response.data.message);
    }
    setIsLoading(false);
  };

  const getTransactions = async (tenent, type, nextPage = null) => {
    try {
      console.log("caling " + nextPage);
      if (tenent === null || type === null) return;
      setIsLoading(true);
      const { data } = await fetchClient.get(
        `getAllTransactions/${tenent}?type=${type}${
          nextPage ? `&page=${nextPage}` : ""
        }`
      );
      setPendings((old) =>
        nextPage ? [...old, ...data.content] : data.content
      );
      setNext({
        next:
          data.page.totalPages - 1 - (nextPage + 1) >= 0 ? nextPage + 1 : null,
      });
    } catch (e) {
      setEmpresa("");
      message.error("Erro ao buscar logs, tente novamente mais tarde!");
    }
    setIsLoading(false);
  };

  const handleSearch = async (search) => {
    setIsLoading(true);
    const { data } = await fetchClient.post("/queryLogs", {
      queryString: search,
      type,
      group: empresa,
    });

    setGroupsLogs(data);
    setIsLoading(false);
  };

  useEffect(() => {
    if (typeof window === "undefined") return;
    const availWidth = window.screen?.availWidth || window.innerWidth || 1600;
    const availHeight = window.screen?.availHeight || window.innerHeight || 900;
    setWindowFeatures(
      `left=0,top=0,width=${availWidth},height=${availHeight},resizable=yes,scrollbars=yes`
    );
  }, []);

  const handleSearchTransaction = async (search) => {
    if (search === "") return getTransactions(empresa, type);
    setIsLoading(true);
    const { data } = await fetchClient.get(
      `queryTransaction/${empresa}?type=${type}&id=${search}`
    );
    setPendings(data.content);
    setNext({
      next:
        data.page.totalPages - 1 - (nextPage + 1) >= 0 ? nextPage + 1 : null,
    });
    setIsLoading(false);
  };

  const closeLogWindow = () => {
    setIsOpened(false);
    setPendingView(null);
    setLogWindow(null);
  };

  const onConsultLog = (logName) => {
    setGroupLog(logName);
    setIsOpened(true);
  };

  const onSendAgain = async (reportId) => {
    try {
      console.log(logs);

      if (logs.filter((v) => !!v).find((v) => v.id === empresa).ativo === true)
        throw new Error(
          "Você tem que desativar esta aplicação pra realizar está operação!"
        );
      setLoading(reportId);
      await fetchClient.post("/task", {
        eventId: reportId,
        type,
        companyId: empresa,
      });

      message.sucess(
        `${type.toUpperCase()} foi enviado para fila de processamento!`
      );
    } catch (error) {
      message.error(error.response?.data.message || error.message);
    } finally {
      setLoading(-1);
    }
  };

  return (
    <Container>
      {(isOpened || pendingView) && (
        <NewWindow
          title="Logs"
          features={windowFeatures}
          onOpen={(win) => setLogWindow(win)}
          onUnload={closeLogWindow}
          onClose={closeLogWindow}
        >
          {logWindow && (
            <StyleSheetManager target={logWindow.document.head}>
              {pendingView ? (
                <Transaction json={pendingView} />
              ) : (
                <LogEvents groupLog={groupLog} empresa={empresa} type={type} />
              )}
            </StyleSheetManager>
          )}
        </NewWindow>
      )}
      {isRemoving && <RemoveModal />}
      <Page>
        <PageContent>
          <ModernHeader>
            <HeaderLeft>
              <BackButton onClick={() => history.goBack()}>
                <ArrowBack />
              </BackButton>
              <HeaderContent>
                <PageTitle>
                  <Description
                    style={{ marginRight: "12px", fontSize: "32px" }}
                  />
                  Logs Concur
                </PageTitle>
                <PageSubtitle>
                  Visualize e busque logs de eventos do sistema
                </PageSubtitle>
              </HeaderContent>
            </HeaderLeft>
            <SelectedChips>
              {logs.find((item) => item?.id === empresa) && (
                <SelectedBadge>
                  <Business style={{ fontSize: "16px", marginRight: "4px" }} />
                  {logs.find((item) => item?.id === empresa)?.name}
                </SelectedBadge>
              )}
              {type && (
                <SelectedBadge>
                  <Category style={{ fontSize: "16px", marginRight: "4px" }} />
                  {type.toUpperCase()}
                </SelectedBadge>
              )}
              {pending && <SelectedBadge>Pendentes</SelectedBadge>}
            </SelectedChips>
          </ModernHeader>

          <FiltersCard>
            <SectionHeader>
              <SectionIcon color="#8e44ad">
                <SearchIcon />
              </SectionIcon>
              <SectionTitle>Filtros de Busca</SectionTitle>
            </SectionHeader>
            <FormGrid>
              <StyledFieldContainer>
                <FieldLabel>
                  <Business
                    style={{
                      fontSize: "18px",
                      marginRight: "8px",
                      color: "#8e44ad",
                    }}
                  />
                  Empresa
                </FieldLabel>
                <TextField
                  select
                  fullWidth
                  variant="outlined"
                  value={empresa}
                  onChange={(event) => setEmpresa(event.target.value)}
                  InputLabelProps={{ shrink: true }}
                  placeholder="Selecionar empresa"
                >
                  <MenuItem value="">Selecionar empresa</MenuItem>
                  {logs.filter(Boolean).map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </TextField>
              </StyledFieldContainer>

              <StyledFieldContainer>
                <FieldLabel>
                  <Category
                    style={{
                      fontSize: "18px",
                      marginRight: "8px",
                      color: "#8e44ad",
                    }}
                  />
                  Tipo de Log
                </FieldLabel>
                <TextField
                  select
                  fullWidth
                  variant="outlined"
                  value={type}
                  onChange={(event) => setType(event.target.value)}
                  InputLabelProps={{ shrink: true }}
                  placeholder="Selecionar tipo"
                >
                  <MenuItem value="">Selecionar tipo</MenuItem>
                  <MenuItem value="cash">Cash</MenuItem>
                  <MenuItem value="expense">Expense</MenuItem>
                </TextField>
              </StyledFieldContainer>

              <StyledFieldContainer fullWidth>
                <FieldLabel>
                  <SearchIcon
                    style={{
                      fontSize: "18px",
                      marginRight: "8px",
                      color: "#8e44ad",
                    }}
                  />
                  Busca Avançada
                </FieldLabel>
                <SearchWrapper>
                  <SearchLogs
                    type={type}
                    onSearch={pending ? handleSearchTransaction : handleSearch}
                    tenent={empresa}
                    setLoading={setIsLoading}
                    setGroupsLogs={setGroupsLogs}
                  />
                </SearchWrapper>
              </StyledFieldContainer>

              <StyledFieldContainer>
                <FieldLabel>
                  <Event
                    style={{
                      fontSize: "18px",
                      marginRight: "8px",
                      color: "#8e44ad",
                    }}
                  />
                  Exibir Pendentes
                </FieldLabel>
                <CheckboxWrapper>
                  <input
                    type="checkbox"
                    checked={pending}
                    onChange={(e) => setPending(e.target.checked)}
                  />
                  <span>Mostrar apenas logs pendentes</span>
                </CheckboxWrapper>
              </StyledFieldContainer>
            </FormGrid>
            <FilterHelper>
              <Event style={{ fontSize: "16px", marginRight: "8px" }} />
              Defina a empresa e o tipo antes de consultar. Utilize a busca para
              localizar termos específicos dentro dos eventos.
            </FilterHelper>
          </FiltersCard>
          {isLoading ? (
            <LoaderWrapper>
              <Loader />
            </LoaderWrapper>
          ) : !empresa || !type ? (
            <ResultsCard>
              <EmptyState>
                <Description
                  style={{
                    fontSize: "48px",
                    color: "#cbd5e1",
                    marginBottom: "16px",
                  }}
                />
                <EmptyTitle>Nenhum filtro selecionado</EmptyTitle>
                <EmptyText>
                  Escolha uma empresa e um tipo de log para visualizar os
                  eventos disponíveis.
                </EmptyText>
              </EmptyState>
            </ResultsCard>
          ) : (
            <ResultsCard>
              <SectionInfo>
                <SectionInfoTitle>
                  {pending ? "Logs pendentes" : "Streams recentes"}
                </SectionInfoTitle>
                <SectionSubtitle>
                  {pending
                    ? pendings.length > 0
                      ? `Mostrando ${pendings.length} ${
                          pendings.length === 1 ? "pendência" : "pendências"
                        }`
                      : "Nenhuma pendência encontrada"
                    : groupsLogs.length > 0
                    ? `Mostrando ${groupsLogs.length} ${
                        groupsLogs.length === 1 ? "stream" : "streams"
                      }`
                    : "Nenhum stream encontrado"}
                </SectionSubtitle>
              </SectionInfo>
              {pending ? (
                pendings.length === 0 ? (
                  <EmptyState>
                    <Description
                      style={{
                        fontSize: "48px",
                        color: "#cbd5e1",
                        marginBottom: "16px",
                      }}
                    />
                    <EmptyTitle>Nenhum log pendente</EmptyTitle>
                    <EmptyText>
                      Não há registros pendentes para os filtros selecionados.
                    </EmptyText>
                  </EmptyState>
                ) : (
                  <TableWrapper>
                    <StreamsTable>
                      <thead>
                        <tr>
                          <TableHead>Report ID</TableHead>
                          <TableHead>Último evento</TableHead>
                          <TableHead align="right">Ações</TableHead>
                        </tr>
                      </thead>
                      <tbody>
                        {pendings.map((content) => (
                          <TableRow key={content.id}>
                            <StreamName
                              title={content.document.report?.reportId}
                            >
                              {type === "cash"
                                ? content.document.cashAdvanceData.cashAdvanceId
                                : content.document.report.reportId}
                            </StreamName>
                            <EventTime>
                              {moment(
                                type === "cash"
                                  ? content.document.cashAdvanceData
                                      ?.requestDate
                                  : content.document.report
                                      ?.reportPaymentProcessingDate || ""
                              ).format("DD/MM/YYYY HH:mm")}
                            </EventTime>
                            <TableActions>
                              <RowActions
                                onLogs={() =>
                                  onConsultLog(
                                    type === "cash"
                                      ? content.id
                                      : content.document.report?.reportId || ""
                                  )
                                }
                                onJson={() => setPendingView(content)}
                                onProcess={
                                  onSendAgain
                                    ? () =>
                                        onSendAgain(
                                          type === "cash"
                                            ? content.document.cashAdvanceData
                                                .cashAdvanceId
                                            : content.document.report.reportId
                                        )
                                    : null
                                }
                                processing={
                                  type === "cash"
                                    ? loading ===
                                      content.document.cashAdvanceData
                                        .cashAdvanceId
                                    : loading ===
                                      content.document.report.reportId
                                }
                                onRemove={() => {
                                  setLogToRemove(content.id);
                                  setIsRemoving(true);
                                }}
                              />
                            </TableActions>
                          </TableRow>
                        ))}
                      </tbody>
                    </StreamsTable>
                  </TableWrapper>
                )
              ) : groupsLogs.length === 0 ? (
                <EmptyState>
                  <Description
                    style={{
                      fontSize: "48px",
                      color: "#cbd5e1",
                      marginBottom: "16px",
                    }}
                  />
                  <EmptyTitle>Nenhum registro encontrado</EmptyTitle>
                  <EmptyText>
                    Nenhum registro encontrado para essa combinação. Ajuste os
                    filtros ou tente novamente mais tarde.
                  </EmptyText>
                </EmptyState>
              ) : (
                <TableWrapper>
                  <StreamsTable>
                    <thead>
                      <tr>
                        <TableHead>ID do stream</TableHead>
                        <TableHead>Último evento</TableHead>
                        <TableHead align="right">Ações</TableHead>
                      </tr>
                    </thead>
                    <tbody>
                      {groupsLogs.map(
                        ({ logStreamName, lastEventTimestamp }) => (
                          <TableRow key={logStreamName}>
                            <StreamName title={logStreamName}>
                              {logStreamName}
                            </StreamName>
                            <EventTime>
                              {moment(lastEventTimestamp).format(
                                "DD/MM/YYYY HH:mm"
                              )}
                            </EventTime>
                            <TableActions>
                              <ConsultResult
                                onClick={() => {
                                  setGroupLog(logStreamName);
                                  setIsOpened(true);
                                }}
                              >
                                Consultar
                              </ConsultResult>
                            </TableActions>
                          </TableRow>
                        )
                      )}
                    </tbody>
                  </StreamsTable>
                </TableWrapper>
              )}
              {((pending && next.next !== null) ||
                (!pending && nextPage.has)) && (
                <MoreWrapper>
                  <MoreButton
                    onClick={() => {
                      if (pending) {
                        getTransactions(empresa, type, next.next);
                      } else {
                        getGroupLogs(empresa, type, nextPage.link);
                      }
                    }}
                  >
                    Carregar mais
                  </MoreButton>
                </MoreWrapper>
              )}
            </ResultsCard>
          )}
        </PageContent>
      </Page>
    </Container>
  );
}

export default Logs;

// Animações
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const ModalTitle = styled.h1`
  font-size: 1.2rem;
  font-weight: bold;
  color: #2c3e50;
  font-family: "Mulish", sans-serif;
`;

const ModalButtons = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  font-family: "Mulish", sans-serif;
`;

const ModalContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Outlayer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10;
  backdrop-filter: blur(2px);
`;

const MoreButton = styled.button`
  min-width: 180px;
  height: 44px;
  border: none;
  background: linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%);
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  border-radius: 12px;
  padding: 0 32px;
  cursor: pointer;
  font-family: "Mulish", sans-serif;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(142, 68, 173, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(142, 68, 173, 0.4);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: #c7d3e3;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

const ConsultResult = styled.button`
  background: ${(props) =>
    props.remove
      ? "linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)"
      : "linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)"};
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 8px 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: "Mulish", sans-serif;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px
    ${(props) =>
      props.remove ? "rgba(231, 76, 60, 0.3)" : "rgba(142, 68, 173, 0.3)"};

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px
      ${(props) =>
        props.remove ? "rgba(231, 76, 60, 0.4)" : "rgba(142, 68, 173, 0.4)"};
  }

  &:active {
    transform: translateY(0);
  }
`;

const ResultsCard = styled.div`
  width: 100%;
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 16px;
  padding: 28px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  animation: ${fadeIn} 0.5s ease;
  transition: all 0.3s ease;
  box-sizing: border-box;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #d0d0d0;
  }
`;

const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  width: 100%;
  box-sizing: border-box;
`;

const Container = styled.div`
  width: 100%;
  min-height: calc(100vh - 65px);
  padding: 24px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  font-family: "Mulish", sans-serif;
  box-sizing: border-box;
  overflow-x: hidden;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

const Page = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
`;

const PageContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  box-sizing: border-box;
`;

const ModernHeader = styled.div`
  padding: 24px 0;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  animation: ${fadeIn} 0.6s ease;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 16px 0;
  }
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
`;

const HeaderContent = styled.div`
  flex: 1;
`;

const PageTitle = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 6px 0;
  display: flex;
  align-items: center;
  font-family: "Mulish", sans-serif;

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

const PageSubtitle = styled.p`
  font-size: 14px;
  color: #7f8c8d;
  margin: 0;
  font-family: "Mulish", sans-serif;
`;

const BackButton = styled.button`
  background: rgba(142, 68, 173, 0.1);
  border: none;
  border-radius: 12px;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #8e44ad;
  transition: all 0.3s ease;
  flex-shrink: 0;

  &:hover {
    background: rgba(142, 68, 173, 0.2);
    transform: translateX(-4px);
  }

  &:active {
    transform: translateX(0);
  }
`;

const SelectedChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const SelectedBadge = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  background: linear-gradient(
    135deg,
    rgba(142, 68, 173, 0.1) 0%,
    rgba(155, 89, 182, 0.1) 100%
  );
  color: #8e44ad;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  font-family: "Mulish", sans-serif;
  border: 1px solid rgba(142, 68, 173, 0.2);
  transition: all 0.3s ease;

  &:hover {
    border-color: #8e44ad;
    background: linear-gradient(
      135deg,
      rgba(142, 68, 173, 0.15) 0%,
      rgba(155, 89, 182, 0.15) 100%
    );
  }
`;

const FiltersCard = styled.div`
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  animation: ${fadeIn} 0.5s ease 0.1s both;
  transition: all 0.3s ease;
  width: 100%;
  box-sizing: border-box;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #d0d0d0;
  }
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f0f0f0;
  width: 100%;
  box-sizing: border-box;
`;

const SectionIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) =>
    props.color ? `${props.color}15` : "rgba(142, 68, 173, 0.1)"};
  color: ${(props) => props.color || "#8e44ad"};
  margin-right: 12px;
  transition: all 0.3s ease;

  svg {
    font-size: 22px;
  }

  ${FiltersCard}:hover & {
    transform: scale(1.1);
  }
`;

const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  font-family: "Mulish", sans-serif;
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const StyledFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: ${(props) => (props.fullWidth ? "1 / -1" : "auto")};

  .MuiOutlinedInput-root {
    border-radius: 10px;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 2px 8px rgba(142, 68, 173, 0.1);
    }

    &.Mui-focused {
      box-shadow: 0 4px 12px rgba(142, 68, 173, 0.2);
    }
  }

  .MuiInputLabel-outlined {
    font-family: "Mulish", sans-serif;
    font-weight: 500;
  }

  .MuiOutlinedInput-input {
    font-family: "Mulish", sans-serif;
  }
`;

const FieldLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  font-family: "Mulish", sans-serif;
`;

const SearchWrapper = styled.div`
  width: 100%;
  > div {
    width: 100%;
  }
`;

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  background: rgba(142, 68, 173, 0.05);
  border-radius: 8px;

  input[type="checkbox"] {
    width: 20px;
    height: 20px;
    cursor: pointer;
    accent-color: #8e44ad;
  }

  span {
    font-size: 14px;
    color: #2c3e50;
    font-family: "Mulish", sans-serif;
  }
`;

const FilterHelper = styled.div`
  margin-top: 20px;
  padding: 14px 18px;
  background: linear-gradient(
    135deg,
    rgba(142, 68, 173, 0.05) 0%,
    rgba(155, 89, 182, 0.05) 100%
  );
  border-left: 4px solid #8e44ad;
  border-radius: 8px;
  font-size: 13px;
  color: #5c6b7a;
  font-family: "Mulish", sans-serif;
  display: flex;
  align-items: center;
  line-height: 1.5;
`;

const SectionInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 16px;
`;

const SectionInfoTitle = styled.h3`
  margin: 0;
  font-size: 20px;
  color: #1f2933;
  font-family: "Mulish", sans-serif;
`;

const SectionSubtitle = styled.span`
  font-size: 14px;
  color: #64748b;
  font-family: "Mulish", sans-serif;
`;

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  margin-top: 12px;
  box-sizing: border-box;
`;

const StreamsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 520px;
`;

const TableHead = styled.th`
  text-align: ${(props) => props.align || "left"};
  font-size: 13px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #6b7280;
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
  font-family: "Mulish", sans-serif;
`;

const TableRow = styled.tr`
  border-bottom: 1px solid #eef2f7;
  &:hover {
    background: #f9fbff;
  }
`;

const StreamName = styled.td`
  font-weight: 600;
  color: #0f172a;
  padding: 12px 16px;
  max-width: 360px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: "Mulish", sans-serif;
`;

const EventTime = styled.td`
  padding: 12px 16px;
  color: #4c5968;
  font-size: 14px;
  font-family: "Mulish", sans-serif;
`;

const TableActions = styled.td`
  padding: 12px 16px;
  text-align: right;
  position: relative;
  overflow: visible;
`;

const MoreWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`;

const EmptyState = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 64px 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-family: "Mulish", sans-serif;
`;

const EmptyTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 8px 0;
  font-family: "Mulish", sans-serif;
`;

const EmptyText = styled.p`
  font-size: 14px;
  color: #7f8c8d;
  margin: 0;
  max-width: 400px;
  line-height: 1.5;
  font-family: "Mulish", sans-serif;
`;
